<script setup lang="ts">
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { useRoute, useRouter } from "vue-router";
import { useStory } from "@/stores/story";
import { useMate } from "@/stores/mate";
import { onBeforeMount, ref } from "vue";
import { Mate, Story } from "@/types/entity";
import MateCard from "@/components/mobile/MateCard.vue";
import { getDisplayDateTime } from "@/modules/common";

const route = useRoute();
const router = useRouter();
const storyStore = useStory();
const mateStore = useMate();
const currentStory = ref<Story | null>(null);
const loading = ref(false);
const author = ref<Mate | null>(null);
// Lifecycle
const prepareData = async () => {
  loading.value = true;
  try {
    const uuid = route.params.uuid as string;
    currentStory.value = await storyStore.getStoryItem(uuid);
    author.value = await mateStore.getOrFetchMate(
      currentStory.value!.mate.uuid
    );
  } finally {
    loading.value = false;
  }
};
onBeforeMount(() => {
  prepareData();
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr] relative text-base">
    <threads-nav :show-back="true" :enable-switch-mate="false">
      <template #center>
        <div class="font-bold">{{ currentStory?.title ?? "" }}</div>
      </template>
    </threads-nav>
    <div class="w-full h-full overflow-y-auto flex flex-col">
      <div
        v-if="loading"
        class="w-full h-full flex items-center justify-center"
      >
        <span class="loading"></span>
      </div>
      <div v-else>
        <div class="flex flex-col">
          <div class="flex flex-col gap-2 p-4 border-b">
            <div class="text-lg font-bold">{{ $t("story.name") }}</div>
            <div class="text-base text-base-content/50">
              {{ currentStory?.title ?? "" }}
            </div>
          </div>
          <div class="flex flex-col gap-2 p-4 border-b">
            <div class="text-lg font-bold">{{ $t("User.bio") }}</div>
            <div class="text-base text-base-content/50">
              {{ currentStory?.description ?? "" }}
            </div>
          </div>
          <div class="flex flex-col gap-2 p-4 border-b">
            <div class="text-lg font-bold">{{ $t("story.author") }}</div>
            <mate-card
              class="rounded text-sm"
              :mate="author!"
              @click="
                router.push({
                  name: 'mateHome',
                  params: { uuid: author!.uuid },
                })
              "
            />
          </div>
          <div class="flex flex-col gap-2 p-4 border-b">
            <div class="text-lg font-bold">{{ $t("story.info") }}</div>
            <div class="flex flex-col">
              <div class="flex">
                <div class="w-32 text-base-content/50">
                  {{ $t("story.status") }}
                </div>
                <div>
                  {{
                    currentStory!.dtPublish
                      ? $t("story.published")
                      : $t("story.draft")
                  }}
                </div>
              </div>
              <div class="flex">
                <div class="w-32 text-base-content/50">
                  {{ $t("story.createAt") }}
                </div>
                <div>{{ getDisplayDateTime(currentStory!.dtCreate) }}</div>
              </div>
              <div class="flex">
                <div class="w-32 text-base-content/50">
                  {{ $t("story.publishedAt") }}
                </div>
                <div>
                  {{
                    currentStory!.dtPublish
                      ? getDisplayDateTime(currentStory!.dtPublish)
                      : "-"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
